import React from 'react'
import { PORTAL_BRAND_STATUS } from './portalBrandStatus'

const LINK = 'text-sm font-medium text-primary-main hover:underline'
const MUTED = 'text-sm text-text-secondary'

const EXTENSION = /\s*(?:ext\.?|x|#)\s*\d+\s*$/i

const telHref = (phone) => {
  const dialable = String(phone).replace(EXTENSION, '').replace(/[^\d+]/g, '')
  return `tel:${/^\d{10}$/.test(dialable) ? `+1${dialable}` : dialable}`
}

const contactsOf = (portalBrand) => (portalBrand?.status === PORTAL_BRAND_STATUS.FIRM ? portalBrand.brand : {})

export const hasPortalHelp = (portalBrand) => {
  const { supportEmail, supportPhone } = contactsOf(portalBrand)
  return Boolean(supportEmail || supportPhone)
}

const PortalHelpLine = ({ portalBrand }) => {
  const { supportEmail, supportPhone } = contactsOf(portalBrand)

  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-1 min-w-0">
      {(supportEmail || supportPhone) && <span className={MUTED}>Need help?</span>}
      {supportEmail && <a href={`mailto:${supportEmail}`} className={`${LINK} break-all`}>{supportEmail}</a>}
      {supportEmail && supportPhone && <span className={MUTED}>|</span>}
      {supportPhone && <a href={telHref(supportPhone)} className={LINK}>{supportPhone}</a>}
    </div>
  )
}

export default PortalHelpLine
